import classNames from 'classnames';
import React, { ChangeEvent, MouseEvent, FC, ReactNode } from 'react';

import { Switch } from '../Switch/Switch';
import styles from './SwitchMenuItem.m.css';
import { TSwitchMenuItemSize } from './SwitchMenuItem.types';

type TSwitchMenuItemTheme = 'dark' | 'danger';

interface ISwitchMenuItemProps {
  className?: string;
  title: string;
  titleSuffix?: ReactNode | string;
  titleClassName?: string;
  subTitle?: string;
  subTitleClassName?: string;
  icon?: ReactNode;
  iconClassName?: string;
  theme?: TSwitchMenuItemTheme;
  isChecked?: boolean;
  isDisabled?: boolean;
  dataTest?: string;
  size?: TSwitchMenuItemSize;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  onClick?(event: MouseEvent<HTMLLabelElement>): void;
}

export const SwitchMenuItem: FC<ISwitchMenuItemProps> = (props) => {
  const {
    title,
    titleSuffix,
    titleClassName,
    subTitle,
    subTitleClassName,
    icon,
    className,
    iconClassName,
    theme,
    isChecked,
    isDisabled,
    dataTest,
    onChange,
    onClick,
    size,
  } = props;

  const containerClassNames = classNames(
    styles.container,
    styles[`container--${theme}`],
    styles[`${size}-size`],
    className
  );

  const iconClassNames = classNames(styles.icon, iconClassName);
  const titleClassNames = classNames(styles.title, styles[`title--${theme}`], titleClassName);
  const subTitleClassNames = classNames(styles.subtitle, subTitleClassName);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <label
      className={containerClassNames}
      data-test={dataTest}
      onClick={onClick}
    >
      {icon && <span className={iconClassNames}>{icon}</span>}
      <span>
        <span
          className={titleClassNames}
          title={title}
        >
          {title}
          <span className={styles.titleSuffix}>{titleSuffix}</span>
        </span>
        {subTitle && <span className={subTitleClassNames}>{subTitle}</span>}
      </span>

      <Switch
        className={styles.switch}
        isChecked={isChecked}
        onChange={onChange}
        isDisabled={isDisabled}
      />
    </label>
  );
};
